/* CINCO 2026 — behaviour. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CN = window.CN || {};
  var fmt;
  try { fmt = new Intl.NumberFormat(CN.locale || 'en', { style: 'currency', currency: CN.currency || 'USD' }); } catch (e) { fmt = null; }
  function money(c) {
    var v = c / 100;
    if (!fmt) return '$' + v.toFixed(v % 1 ? 2 : 0);
    var s = fmt.format(v);
    return v % 1 === 0 ? s.replace(/[.,]00(?=\D*$)/, '') : s;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- toast ---------- */
  var tt;
  function toast(m) { var t = $('#cn-toast'); if (!t) return; t.textContent = m; t.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('is-on'); }, 2600); }

  /* ---------- announcement rotator ---------- */
  var am = $$('.cn-annc__m');
  if (am.length > 1) { var ai = 0; setInterval(function () { am[ai].classList.remove('is-on'); ai = (ai + 1) % am.length; am[ai].classList.add('is-on'); }, 4200); }

  /* ---------- panels ---------- */
  var scrim = $('[data-cn-scrim]');
  var stack = [];
  function lazy(el) { $$('img[data-src]', el).forEach(function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); }); }
  function open(el) {
    if (!el) return;
    lazy(el);
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    if (stack.indexOf(el) === -1) stack.push(el);
    if (el.id === 'cn-menu' || el.id === 'cn-drawer') scrim.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = el.querySelector('[data-cn-close]'); if (f && el.id !== 'cn-pop') setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function close(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    stack = stack.filter(function (x) { return x !== el; });
    if (!stack.some(function (x) { return x.id === 'cn-menu' || x.id === 'cn-drawer'; })) scrim.classList.remove('is-on');
    if (!stack.length) document.documentElement.style.overflow = '';
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (el.id === 'cn-pop') popClosed();
  }
  window.CNpanel = { open: open, close: close };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cn-open]');
    if (o) { e.preventDefault(); open(document.getElementById(o.getAttribute('data-cn-open'))); return; }
    var c = e.target.closest('[data-cn-close]');
    if (c) { e.preventDefault(); close(c.closest('[data-cn-panel]')); return; }
    if (e.target.matches('.cn-sheet,.cn-modal,.cn-pop')) close(e.target);
  });
  if (scrim) scrim.addEventListener('click', function () { close($('#cn-menu')); close($('#cn-drawer')); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && stack.length) close(stack[stack.length - 1]); });

  /* ---------- cart ---------- */
  var drawer = $('#cn-drawer');
  function api(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
  }
  function add(id, q) { return api('/cart/add.js', { items: [{ id: id, quantity: q || 1 }] }); }
  function refresh() { return api('/cart.js').then(render); }
  function change(key, q) { return api('/cart/change.js', { id: key, quantity: q }).then(render); }
  function thumb(it) {
    if (CN.thumbs && CN.thumbs[it.handle]) return CN.thumbs[it.handle];
    if (!it.image) return '';
    return it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }
  function sizeBtns(p, dataAttr) {
    return p.v.map(function (v) {
      return '<button type="button" class="cn-size' + (v.a ? '' : ' is-out') + '" ' + dataAttr + '="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
    }).join('');
  }
  function render(cart) {
    $$('[data-cn-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = !cart.item_count; });
    var lab = $('[data-cn-count-label]'); if (lab) lab.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var body = $('#cn-drawer-body'), foot = $('#cn-drawer-foot');
    if (!body) return cart;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cn-drawer__empty"><p>Your cart is empty.</p><a class="cn-btn cn-btn--red" href="/collections/fivestar-league">Shop the FIVESTAR League</a></div>';
      foot.hidden = true; var sb = $('#cn-set'), ab = $('#cn-addon'); if (sb) { sb.hidden = true; sb.innerHTML = ''; } if (ab) ab.innerHTML = ''; return cart;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '';
      var disc = (it.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0; });
      var img = thumb(it);
      return '<div class="cn-line" data-key="' + it.key + '">' +
        '<a class="cn-line__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="150">' : '') + '</a>' +
        '<div><a class="cn-line__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (v ? '<div class="cn-line__v">Size ' + v + '</div>' : '') +
        (window.cnShip && cnShip[it.handle] ? '<div class="cn-line__s">' + esc(cnShip[it.handle]) + '</div>' : '') +
        (disc.length ? '<div class="cn-line__d">Set credit −' + money(disc.reduce(function (s, a) { return s + a.amount; }, 0)) + '</div>' : '') +
        '<div class="cn-qty"><button type="button" data-q="-1" aria-label="One less">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="One more">+</button></div></div>' +
        '<div class="cn-line__p">' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price) +
        '<button type="button" class="cn-line__rm" data-rm>Remove</button></div></div>';
    }).join('');
    $('#cn-subtotal').textContent = money(cart.total_price);
    var save = $('#cn-save');
    if (save) { save.hidden = !cart.total_discount; if (cart.total_discount) save.textContent = 'You’re saving ' + money(cart.total_discount) + ' with the set credit'; }
    setNote(cart);
    return cart;
  }
  /* set credit progress + one add-on */
  function setNote(cart) {
    var box = $('#cn-set'), ad = $('#cn-addon'); if (!box || !ad) return;
    var S = CN.set || {}, handles = cart.items.map(function (i) { return i.handle; });
    var zips = handles.filter(function (h) { return S[h] && S[h].kind === 'zip'; });
    var sws = handles.filter(function (h) { return S[h] && S[h].kind === 'sweats'; });
    var sugg = null, html = '';
    if (zips.length && sws.length) {
      box.className = 'cn-set-note is-done';
      html = '<p class="cn-set-note__h"><span>Set complete</span><span>✓</span></p><p>Your FIVESTAR LEAGUE set credit is applied to the sweats.</p><div class="cn-bar"><i style="width:100%"></i></div>';
    } else if (zips.length || sws.length) {
      var has = zips.length ? zips[0] : sws[0];
      var want = S[has].pair, wp = S[want];
      if (!wp || !wp.available) { for (var k in S) { if (S[k].kind !== S[has].kind && S[k].available) { want = k; wp = S[k]; break; } } }
      if (wp && wp.available) {
        var credit = Math.round((zips.length ? wp.price : S[has].price) / 3);
        box.className = 'cn-set-note';
        html = '<p class="cn-set-note__h"><span>' + (zips.length ? 'Add the matching sweats' : 'Add the matching zip-up') + '</span><span>Save ' + money(credit) + '</span></p>' +
          '<p>' + (zips.length ? 'With your zip-up in the cart, the sweats drop to ' + money(wp.price - credit) + '.' : 'Add the zip-up and your sweats drop to ' + money(S[has].price - credit) + '.') + ' Applied automatically.</p><div class="cn-bar"><i style="width:50%"></i></div>';
        sugg = { title: wp.title, img: wp.img, url: wp.url, price: zips.length ? wp.price - credit : wp.price, was: zips.length ? wp.price : 0, v: wp.v, why: 'Complete the set' };
      }
    }
    box.innerHTML = html; box.hidden = !html;
    if (!sugg) {
      var A = (CN.addons || []).filter(function (a) { return handles.indexOf(a.handle) === -1; })[0];
      if (A) sugg = { title: A.title, img: A.img, url: A.url, price: A.price, was: 0, v: A.v, why: A.ship ? 'Add on · ' + A.ship.toLowerCase() : 'Add on' };
    }
    if (!sugg) { ad.innerHTML = ''; return; }
    var one = sugg.v.length === 1;
    ad.innerHTML = '<div class="cn-addon"><a class="cn-addon__img" href="' + sugg.url + '">' + (sugg.img ? '<img src="' + sugg.img + '" alt="" loading="lazy" width="112" height="140">' : '') + '</a>' +
      '<div class="cn-addon__t"><b>' + esc(sugg.why) + '</b>' + esc(sugg.title) + ' — ' + money(sugg.price) + (sugg.was ? ' <s>' + money(sugg.was) + '</s>' : '') + '</div>' +
      '<div class="cn-addon__sizes">' + (one ? '<button type="button" class="cn-btn cn-btn--sm" data-addon="' + sugg.v[0].id + '">Add</button>' : sizeBtns(sugg, 'data-addon')) + '</div></div>';
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('[data-addon]');
      if (a && !a.disabled) { a.textContent = '…'; add(parseInt(a.getAttribute('data-addon'), 10), 1).then(refresh).catch(function (er) { toast(er.message); refresh(); }); return; }
      var line = e.target.closest('.cn-line'); if (!line) return;
      var key = line.getAttribute('data-key'), q = e.target.closest('[data-q]');
      if (q) { var n = parseInt($('.cn-qty span', line).textContent, 10) + parseInt(q.getAttribute('data-q'), 10); change(key, Math.max(0, n)).catch(function (er) { toast(er.message); }); }
      if (e.target.closest('[data-rm]')) change(key, 0);
    });
  }
  function openCart() { refresh().then(function () { open(drawer); }); }
  window.CNcart = { open: openCart, refresh: refresh, add: add };
  $$('[data-cn-cart]').forEach(function (b) { b.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); openCart(); }); });

  /* ---------- quick add sheet ---------- */
  var sheet = $('#cn-sheet'), sp = null, sdata = null;
  function openSheet(handle) {
    if (!sheet) { location.href = '/products/' + handle; return; }
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      sdata = p; sp = null;
      if (p.variants.length === 1) {
        add(p.variants[0].id, 1).then(function () { close(sheet); openCart(); }).catch(function (er) { toast(er.message); }); return;
      }
      var img = (CN.thumbs && CN.thumbs[handle]) || (p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '');
      $('#cn-sheet-img').innerHTML = img ? '<img src="' + img + '" alt="" width="120" height="150">' : '';
      $('#cn-sheet-title').textContent = p.title;
      $('#cn-sheet-price').textContent = money(p.price);
      var card = document.querySelector('[data-cn-qa="' + handle + '"]');
      var shipEl = $('#cn-sheet-ship'); shipEl.textContent = '';
      $('#cn-sheet-link').href = '/products/' + handle;
      $('#cn-sheet-sizes').innerHTML = p.variants.map(function (v) {
        return '<button type="button" class="cn-size' + (v.available ? '' : ' is-out') + '" data-id="' + v.id + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + '>' + esc(v.title) + '</button>';
      }).join('');
      var b = $('#cn-sheet-add'); b.disabled = true; b.textContent = 'Pick a size';
      var pre = /pre-?order|will (be )?ship|beginning of november/i.test(p.description || '');
      b.setAttribute('data-word', pre ? 'Preorder' : 'Add to cart');
      if (pre) shipEl.textContent = /november/i.test(p.description) ? 'Preorder — ships early November' : 'Preorder';
      open(sheet);
    }).catch(function () { location.href = '/products/' + handle; });
  }
  window.CNsheet = openSheet;
  if (sheet) {
    sheet.addEventListener('click', function (e) {
      var s = e.target.closest('.cn-size');
      if (s && !s.disabled) {
        $$('.cn-size', sheet).forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
        var id = parseInt(s.getAttribute('data-id'), 10);
        sp = sdata.variants.filter(function (v) { return v.id === id; })[0];
        var b = $('#cn-sheet-add'); b.disabled = false; b.textContent = b.getAttribute('data-word') + ' — ' + money(sp.price);
      }
      if (e.target.closest('#cn-sheet-add') && sp) {
        var b2 = $('#cn-sheet-add'); b2.disabled = true; b2.textContent = 'Adding…';
        add(sp.id, 1).then(function () { close(sheet); openCart(); }).catch(function (er) { b2.disabled = false; b2.textContent = 'Try again'; toast(er.message); });
      }
    });
  }
  document.addEventListener('click', function (e) { var q = e.target.closest('[data-cn-qa]'); if (q) { e.preventDefault(); openSheet(q.getAttribute('data-cn-qa')); } });

  /* ---------- PDP ---------- */
  $$('[data-cn-pdp]').forEach(function (root) {
    var data = JSON.parse($('[data-cn-variants]', root).textContent), vs = data.variants;
    var word = root.getAttribute('data-word') || 'Add to cart';
    var groups = $$('[data-cn-opt]', root), sel = groups.map(function () { return null; });
    var btns = $$('[data-cn-atc]'), low = $('[data-cn-low]', root), express = $('[data-cn-express]', root), vid = $('[data-cn-vid]', root);
    var any = vs.some(function (v) { return v.available; });
    var picked = data.single ? vs[0] : null;
    function match() {
      if (data.single) return vs[0];
      if (sel.some(function (x) { return !x; })) return null;
      return vs.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
    }
    function paint() {
      groups.forEach(function (g, gi) {
        $$('.cn-size', g).forEach(function (b) {
          var val = b.getAttribute('data-val');
          var ok = vs.some(function (v) { return v.available && v.options[gi] === val && v.options.every(function (o, i) { return i === gi || !sel[i] || o === sel[i]; }); });
          b.classList.toggle('is-out', !ok); b.classList.toggle('is-on', sel[gi] === val);
          b.setAttribute('aria-pressed', sel[gi] === val ? 'true' : 'false');
          if (!ok) b.setAttribute('aria-label', val + ' — sold out'); else b.removeAttribute('aria-label');
        });
        var l = $('[data-cn-optval]', g); if (l) l.textContent = sel[gi] || 'Choose';
      });
    }
    function update() {
      picked = match();
      btns.forEach(function (b) {
        var st = !!b.closest('[data-cn-sticky]');
        if (!any) { b.disabled = true; b.textContent = 'Sold out'; return; }
        if (!picked) { b.disabled = false; b.textContent = st ? 'Choose size' : 'Choose a size'; return; }
        if (!picked.available) { b.disabled = true; b.textContent = 'Sold out in ' + sel.join(' / '); return; }
        b.disabled = false; b.textContent = word + ' — ' + money(picked.price);
      });
      if (low) {
        if (picked && picked.available && picked.low > 0) { low.hidden = false; low.textContent = 'Only ' + picked.low + ' left' + (data.single ? '' : ' in ' + sel.join(' / ')); }
        else low.hidden = true;
      }
      if (express) express.classList.toggle('is-ready', !!(picked && picked.available));
      if (picked) {
        if (vid) vid.value = picked.id;
        var pr = $('[data-cn-price]', root); if (pr) pr.textContent = money(picked.price);
        var spp = $('[data-cn-sticky-p]'); if (spp) spp.textContent = money(picked.price);
        if (!data.single) { try { var u = new URL(location.href); u.searchParams.set('variant', picked.id); history.replaceState(null, '', u); } catch (e) {} }
      }
      paint();
    }
    groups.forEach(function (g, gi) { $$('.cn-size', g).forEach(function (b) { b.addEventListener('click', function () { if (b.classList.contains('is-out')) { toast(b.getAttribute('data-val') + ' is sold out'); return; } sel[gi] = b.getAttribute('data-val'); update(); }); }); });
    var pre = parseInt(new URLSearchParams(location.search).get('variant'), 10);
    var pv = pre && vs.filter(function (v) { return v.id === pre && v.available; })[0];
    if (pv && !data.single) sel = pv.options.slice();
    update();
    var form = $('[data-cn-form]', root);
    function go(b) {
      if (!any) return;
      if (!picked) {
        if (b.closest('[data-cn-sticky]')) { openSheet(root.getAttribute('data-handle')); return; }
        var g = groups[Math.max(0, sel.findIndex(function (x) { return !x; }))];
        if (g) { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); g.classList.add('is-nudge'); setTimeout(function () { g.classList.remove('is-nudge'); }, 600); }
        toast('Pick your size first'); return;
      }
      if (!picked.available) return;
      var old = b.textContent; b.disabled = true; b.textContent = 'Adding…';
      add(picked.id, 1).then(function () { update(); openCart(); }).catch(function (er) { b.disabled = false; b.textContent = old; toast(er.message); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); go($('[data-cn-atc-main]', root)); });
    btns.forEach(function (b) { if (b.closest('[data-cn-sticky]')) b.addEventListener('click', function (e) { e.preventDefault(); go(b); }); });
    var sticky = $('[data-cn-sticky]'), main = $('[data-cn-atc-main]', root);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }).observe(main);
    }
    /* gallery: counter + thumbnails */
    var gal = $('[data-cn-gal]', root), cnt = $('[data-cn-galcount]', root), th = $('[data-cn-thumbs]', root);
    if (gal) {
      var figs = $$('.cn-gal__f', gal), n = figs.length;
      if (n > 1 && cnt) cnt.textContent = '1 / ' + n;
      if (n > 1 && th) {
        th.innerHTML = figs.map(function (f, i) { var im = f.querySelector('img'); var src = (im.currentSrc || im.src || '').replace(/width=\d+/, 'width=160'); return '<button type="button" data-i="' + i + '"' + (i ? '' : ' class="is-on"') + ' aria-label="Image ' + (i + 1) + '"><img src="' + src + '" alt="" loading="lazy"></button>'; }).join('');
        th.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; var f = figs[+b.getAttribute('data-i')]; gal.scrollTo({ left: f.offsetLeft - gal.offsetLeft, behavior: 'smooth' }); });
      }
      var tick;
      gal.addEventListener('scroll', function () {
        cancelAnimationFrame(tick); tick = requestAnimationFrame(function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth);
          if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
          if (th) $$('button', th).forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
    }
  });

  /* ---------- homepage type tabs ---------- */
  $$('[data-cn-shop]').forEach(function (sh) {
    var bs = $$('.cn-tabs button', sh), it = $$('.cn-shop__i', sh);
    bs.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-cat');
        bs.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        it.forEach(function (i) { i.classList.toggle('is-hid', c !== 'all' && (' ' + i.getAttribute('data-cat') + ' ').indexOf(' ' + c + ' ') < 0); });
      });
    });
  });

  /* ---------- real videos: play only while on screen ---------- */
  (function () {
    var vids = $$('video[data-cn-clip]');
    if (!vids.length) return;
    var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    vids.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('is-on'); }); });
    if (still || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) go(e.target); else e.target.pause(); });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------- VIP forms (email first, then phone) ---------- */
  function e164(v) {
    var d = (v || '').replace(/[^\d+]/g, '');
    if (!d) return '';
    if (d.charAt(0) === '+') return d;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return '+' + d;
  }
  $$('[data-cn-vip]').forEach(function (f) {
    var email = $('input[type=email]', f), phone = $('[data-cn-phone]', f), tags = $('[data-cn-vip-tags]', f);
    var next = $('[data-cn-vip-next]', f), skip = $('[data-cn-vip-skip]', f);
    if (!email) return;
    var base = tags ? tags.value : '';
    function valid() { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim()); }
    if (next) next.addEventListener('click', function () {
      if (!valid()) { email.focus(); toast('Enter a valid email'); return; }
      $('[data-step="1"]', f).classList.remove('is-on'); $('[data-step="2"]', f).classList.add('is-on');
      f.setAttribute('data-ready', '1');
      setTimeout(function () { try { phone.focus(); } catch (e) {} }, 60);
    });
    email.addEventListener('keydown', function (e) { if (e.key === 'Enter' && next) { e.preventDefault(); next.click(); } });
    if (skip) skip.addEventListener('click', function () { if (phone) phone.value = ''; f.setAttribute('data-skip', '1'); });
    f.addEventListener('submit', function (e) {
      if (!valid()) { e.preventDefault(); email.focus(); toast('Enter a valid email'); return; }
      var ph = phone && f.getAttribute('data-skip') !== '1' ? e164(phone.value) : '';
      if (phone && phone.value && ph.replace(/\D/g, '').length < 10) { e.preventDefault(); phone.focus(); toast('Check your phone number'); return; }
      if (phone) phone.value = ph;
      if (phone && !ph) phone.disabled = true;
      if (tags) tags.value = base + (ph ? ',sms-optin' : '');
      store('cn_vip', 'joined');
      f.setAttribute('data-sent', '1');
    });
  });

  /* ---------- VIP popup ---------- */
  var pop = $('[data-cn-pop]');
  var posted = /customer_posted=true/.test(location.search);
  function popClosed() {
    if (store('cn_vip') !== 'joined') store('cn_vip', 'seen:' + Date.now());
    var f = pop && $('[data-cn-vip]', pop);
    /* closed after giving an email but before finishing: keep the email (email-only signup) */
    if (f && f.getAttribute('data-ready') === '1' && f.getAttribute('data-sent') !== '1') {
      var fd = new FormData(f); fd.delete('contact[phone]');
      f.setAttribute('data-sent', '1'); store('cn_vip', 'joined');
      fetch(f.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    }
  }
  if (pop && /fivestar-vip/.test(location.pathname)) pop = null;
  if (pop) {
    var hasDone = !!$('[data-cn-vip-done]', pop);
    if (posted && hasDone && /cn-vip-pop/.test(location.hash)) { store('cn_vip', 'joined'); open(pop); }
    else if (!store('cn_vip') && !posted) {
      var fired = false, delay = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000, pct = (parseInt(pop.getAttribute('data-scroll'), 10) || 40) / 100;
      /* a visitor from an ad gets 30 s before the popup and no scroll trigger; nobody with a bag gets it (Oct 23 audit: it covered checkout) */
      var paid = false;
      try { if (/utm_medium=paid|fbclid=/.test(location.search)) sessionStorage.setItem('cn_paid', '1'); paid = sessionStorage.getItem('cn_paid') === '1'; } catch (e) {}
      if (paid) delay = Math.max(delay, 30000);
      var fire = function () {
        if (fired) return;
        if (stack.length) { setTimeout(fire, 4000); return; }
        fired = true; window.removeEventListener('scroll', onScroll);
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (c) { if (!c.item_count && !stack.length) open(pop); })
          .catch(function () {});
      };
      var onScroll = function () { var h = document.documentElement; if ((h.scrollTop + innerHeight) / h.scrollHeight >= pct + 0.0001 && h.scrollTop > 200) fire(); };
      setTimeout(fire, delay);
      if (!paid) window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* ---------- collection sort ---------- */
  $$('[data-cn-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }); });

  /* ---------- reviews slot: show only when an app fills it ---------- */
  $$('[data-cn-reviews]').forEach(function (r) { if (r.children.length) r.hidden = false; });

  refresh().catch(function () {});
})();
